export default [
    {
        title: '学社管理',
        path: '/learningCommunity',
        name: 'learningCommunity',
        meta: {
            key: 'learningCommunity'
        },
        permission: 'learningCommunity',
        menu: true,
        children: [
            {
                title: '分类管理',
                path: '/learningCommunity/category',
                name: 'learningCommunityCategory',
                component: () => import('@/views/learningCommunity/category'),
                meta: {
                    key: 'learningCommunityCategory',
                    open: 'learningCommunity'
                },
                permission: 'learningCommunityCategory',
                menu: true
            },
            {
                title: '课程管理',
                path: '/learningCommunity/course',
                name: 'learningCommunityCourse',
                component: () => import('@/views/learningCommunity/course'),
                meta: {
                    key: 'learningCommunityCourse',
                    open: 'learningCommunity'
                },
                permission: 'learningCommunityCourse',
                menu: true
            },
            {
                title: '课时管理',
                path: '/learningCommunity/lesson',
                name: 'learningCommunityLesson',
                component: () => import('@/views/learningCommunity/lesson'),
                meta: {
                    key: 'learningCommunityCourse',
                    open: 'learningCommunity'
                },
                permission: false,
                menu: false
            }
        ]
    }
];
